// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"4d86d89a","133":"6cfa9d38","182":"e80c7c3c"}[chunkId] + ".chunk.js";
};